/* global module:false */
"use strict";

var $ = window.$;

var TPBS_AdvSearch = (function(){

  function clearNewsCriteria()
  {
    $('#search-news-type').val('');
    $('#search-news-category').val('');
    $('#search-news-time').val('');
    $('#search-news-min').val('');
    $('#search-news-max').val('');

    $('#news-type-selector .text').html('ทุกประเภท');
    $('#news-category-selector .text').html('ทุกหมวดหมู่');
    $('#news-time-selector .text').html('ทุกช่วงเวลา');
  }

  function clearProgramCriteria()
  {
    $('#search-program-type').val('');
    $('#search-program-category').val('');
    $('#search-program-time').val('');
    $('#search-program-min').val('');
    $('#search-program-max').val('');

    $('#program-type-selector .text').html('ทุกประเภท');
    $('#program-category-selector .text').html('ทุกหมวดหมู่');
    $('#program-time-selector .text').html('ทุกช่วงเวลา');
  }

  function clearOrgCriteria()
  {
    $('#search-org-type').val('');
    $('#search-org-time').val('');
    $('#search-org-min').val('');
    $('#search-org-max').val('');

    $('#org-type-selector .text').html('ทุกประเภท');
    $('#org-time-selector .text').html('ทุกช่วงเวลา');
  }

  function clearSearchCriteria(target)
  {
    if(target == 'program'){
      clearNewsCriteria();
      clearOrgCriteria();
    }else if(target == 'org'){
      clearNewsCriteria();
      clearProgramCriteria();
    }else{
      clearOrgCriteria();
      clearProgramCriteria();
    }
  }
  
  function init(){
    if($('.advance-search-block').size() > 0){
      var momentNow = moment();

      // --- NEWS
      // init inline calendar
      $('#date-range-start-cal').datetimepicker({
        format: 'dd/MM/YYYY',
        inline: true,
        sideBySide: true,
        locale: 'th',
        defaultDate: momentNow,
      }).on('dp.change', function(e){
        $('#date-range-start').val(e.date.format('DD/MM/YYYY'));
      });

      $('#date-range-end-cal').datetimepicker({
        format: 'DD/MM/YYYY',
        inline: true,
        sideBySide: true,
        locale: 'th',
        defaultDate: momentNow,
      }).on('dp.change', function(e){
        $('#date-range-end').val(e.date.format('DD/MM/YYYY'));
      });

      // blur to update cal
      $(document).on('blur', '#date-range-start', function(e){
        var _self = $(this);
        // update start date cal
        var date = moment(_self.val(), 'DD/MM/YYYY');
        $('#date-range-start-cal').data("DateTimePicker").date(date);
      }).on('blur', '#date-range-end', function(e){
        var _self = $(this);
        // update end date cal
        var date = moment(_self.val(), 'DD/MM/YYYY');
        $('#date-range-end-cal').data("DateTimePicker").date(date);
      });

      // date range modal event
      $(document).on('shown.bs.modal', '#custom-range-modal', function(e){
        console.log('modal shown');
        $('#date-range-start').focus();
      }).on('hidden.bs.modal', '#custom-range-modal', function(e){
        // clear value
        $('#date-range-start').val();
        $('#date-range-end').val();
        //$('#date-range-start-cal').data("DateTimePicker").maxDate(false);
        //$('#date-range-end-cal').data("DateTimePicker").minDate(false);
      });

      // focus to show cal
      $(document).on('focus', '#date-range-start, #date-range-end', function(e){
        var _self = $(this);
        var $cal = $('#' + _self.attr('id') + '-cal');
        // remove active cls
        _self.closest('.modal-body').find('.form-group').removeClass('active');
        $('.cal-holder').removeClass('active');
        // add active cls
        _self.closest('.form-group').addClass('active');
        $cal.addClass('active');
      });

      // confirm date range custom
      $(document).on('click', '#date-range-custom-confirm', function(e){
        e.preventDefault();
        // get start & end date
        var startDate = moment($('#date-range-start').val(), 'DD/MM/YYYY');
        var endDate = moment($('#date-range-end').val(), 'DD/MM/YYYY');
        var label = '';
        var minVal = '';
        var maxVal = '';

        if(startDate.isValid() && endDate.isValid()){
          // check if start < date or not
          if(endDate.isAfter(startDate)){
            // normal
            label += startDate.format('ll') + ' - ' + endDate.format('ll');
            minVal = startDate.format('YYYY-MM-DD');
            maxVal = endDate.format('YYYY-MM-DD');
          }else if(endDate.isSame(startDate)){
            // same
            label += startDate.format('ll');
            minVal = startDate.format('YYYY-MM-DD');
            maxVal = endDate.format('YYYY-MM-DD');
          }else{
            // switch between startDate & endDate
            label += endDate.format('ll') + ' - ' + startDate.format('ll');
            minVal = endDate.format('YYYY-MM-DD');
            maxVal = startDate.format('YYYY-MM-DD');
            $('#date-range-start').val(endDate.format('DD/MM/YYYY'));
            $('#date-range-end').val(startDate.format('DD/MM/YYYY'));
            $('#date-range-start-cal').data("DateTimePicker").date(endDate);
            $('#date-range-end-cal').data("DateTimePicker").date(startDate);
          }
        }else if(startDate.isValid() && !endDate.isValid()){
          label += startDate.format('ll') + ' - วันนี้';
          minVal = startDate.format('YYYY-MM-DD');
          maxVal = '';
        }else if(!startDate.isValid() && endDate.isValid()){
          label += 'ก่อนวันที่ ' + endDate.format('ll');
          minVal = '';
          maxVal = endDate.format('YYYY-MM-DD');
        }else{
          var curDate = moment();
          label += 'ก่อนวันที่ ' + curDate.format('ll');
          minVal = '';
          maxVal = curDate.format('YYYY-MM-DD');
        }
        // update button name
        var $btn = $('#news-time-selector');
        $btn.find('.text').html(label);
        var inputName = $btn.data('target');
        var $input = $('#' + inputName);
        var $min = $('#' + inputName.replace('time', 'min'));
        var $max = $('#' + inputName.replace('time', 'max'));
        $input.val('custom');
        $min.val(minVal);
        $max.val(maxVal);
        // hide modal
        $('#custom-range-modal').modal('hide');
      });
      // -- end NEWS

      // --- PROGRAM
      // init inline calendar
      $('#program-date-range-start-cal').datetimepicker({
        format: 'dd/MM/YYYY',
        inline: true,
        sideBySide: true,
        locale: 'th',
        defaultDate: momentNow,
      }).on('dp.change', function(e){
        $('#program-date-range-start').val(e.date.format('DD/MM/YYYY'));
      });

      $('#program-date-range-end-cal').datetimepicker({
        format: 'DD/MM/YYYY',
        inline: true,
        sideBySide: true,
        locale: 'th',
        defaultDate: momentNow,
      }).on('dp.change', function(e){
        $('#program-date-range-end').val(e.date.format('DD/MM/YYYY'));
      });

      // blur to update cal
      $(document).on('blur', '#program-date-range-start', function(e){
        var _self = $(this);
        // update start date cal
        var date = moment(_self.val(), 'DD/MM/YYYY');
        $('#program-date-range-start-cal').data("DateTimePicker").date(date);
      }).on('blur', '#program-date-range-end', function(e){
        var _self = $(this);
        // update end date cal
        var date = moment(_self.val(), 'DD/MM/YYYY');
        $('#program-date-range-end-cal').data("DateTimePicker").date(date);
      });

      // date range modal event
      $(document).on('shown.bs.modal', '#program-custom-range-modal', function(e){
        console.log('modal shown');
        $('#program-date-range-start').focus();
      }).on('hidden.bs.modal', '#program-custom-range-modal', function(e){
        // clear value
        $('#program-date-range-start').val();
        $('#program-date-range-end').val();
      });

      // focus to show cal
      $(document).on('focus', '#program-date-range-start, #program-date-range-end', function(e){
        var _self = $(this);
        var $cal = $('#' + _self.attr('id') + '-cal');
        // remove active cls
        _self.closest('.modal-body').find('.form-group').removeClass('active');
        $('.cal-holder').removeClass('active');
        // add active cls
        _self.closest('.form-group').addClass('active');
        $cal.addClass('active');
      });

      // confirm date range custom
      $(document).on('click', '#program-date-range-custom-confirm', function(e){
        e.preventDefault();
        // get start & end date
        var startDate = moment($('#program-date-range-start').val(), 'DD/MM/YYYY');
        var endDate = moment($('#program-date-range-end').val(), 'DD/MM/YYYY');
        var label = '';
        var minVal = '';
        var maxVal = '';

        if(startDate.isValid() && endDate.isValid()){
          // check if start < date or not
          if(endDate.isAfter(startDate)){
            // normal
            label += startDate.format('ll') + ' - ' + endDate.format('ll');
            minVal = startDate.format('YYYY-MM-DD');
            maxVal = endDate.format('YYYY-MM-DD');
          }else if(endDate.isSame(startDate)){
            // same
            label += startDate.format('ll');
            minVal = startDate.format('YYYY-MM-DD');
            maxVal = endDate.format('YYYY-MM-DD');
          }else{
            // switch between startDate & endDate
            label += endDate.format('ll') + ' - ' + startDate.format('ll');
            minVal = endDate.format('YYYY-MM-DD');
            maxVal = startDate.format('YYYY-MM-DD');
            $('#program-date-range-start').val(endDate.format('DD/MM/YYYY'));
            $('#program-date-range-end').val(startDate.format('DD/MM/YYYY'));
            $('#program-date-range-start-cal').data("DateTimePicker").date(endDate);
            $('#program-date-range-end-cal').data("DateTimePicker").date(startDate);
          }
        }else if(startDate.isValid() && !endDate.isValid()){
          label += startDate.format('ll') + ' - วันนี้';
          minVal = startDate.format('YYYY-MM-DD');
          maxVal = '';
        }else if(!startDate.isValid() && endDate.isValid()){
          label += 'ก่อนวันที่ ' + endDate.format('ll');
          minVal = '';
          maxVal = endDate.format('YYYY-MM-DD');
        }else{
          var curDate = moment();
          label += 'ก่อนวันที่ ' + curDate.format('ll');
          minVal = '';
          maxVal = curDate.format('YYYY-MM-DD');
        }
        // update button name
        var $btn = $('#program-time-selector');
        $btn.find('.text').html(label);
        var inputName = $btn.data('target');
        var $input = $('#' + inputName);
        var $min = $('#' + inputName.replace('time', 'min'));
        var $max = $('#' + inputName.replace('time', 'max'));
        $input.val('custom');
        $min.val(minVal);
        $max.val(maxVal);
        // hide modal
        $('#program-custom-range-modal').modal('hide');
      });
      // -- end PROGRAM

            // --- ORG
      // init inline calendar
      $('#org-date-range-start-cal').datetimepicker({
        format: 'dd/MM/YYYY',
        inline: true,
        sideBySide: true,
        locale: 'th',
        defaultDate: momentNow,
      }).on('dp.change', function(e){
        $('#org-date-range-start').val(e.date.format('DD/MM/YYYY'));
      });

      $('#org-date-range-end-cal').datetimepicker({
        format: 'DD/MM/YYYY',
        inline: true,
        sideBySide: true,
        locale: 'th',
        defaultDate: momentNow,
      }).on('dp.change', function(e){
        $('#org-date-range-end').val(e.date.format('DD/MM/YYYY'));
      });

      // blur to update cal
      $(document).on('blur', '#org-date-range-start', function(e){
        var _self = $(this);
        // update start date cal
        var date = moment(_self.val(), 'DD/MM/YYYY');
        $('#org-date-range-start-cal').data("DateTimePicker").date(date);
      }).on('blur', '#org-date-range-end', function(e){
        var _self = $(this);
        // update end date cal
        var date = moment(_self.val(), 'DD/MM/YYYY');
        $('#org-date-range-end-cal').data("DateTimePicker").date(date);
      });

      // date range modal event
      $(document).on('shown.bs.modal', '#org-custom-range-modal', function(e){
        console.log('modal shown');
        $('#org-date-range-start').focus();
      }).on('hidden.bs.modal', '#org-custom-range-modal', function(e){
        // clear value
        $('#org-date-range-start').val();
        $('#org-date-range-end').val();
      });

      // focus to show cal
      $(document).on('focus', '#org-date-range-start, #org-date-range-end', function(e){
        var _self = $(this);
        var $cal = $('#' + _self.attr('id') + '-cal');
        // remove active cls
        _self.closest('.modal-body').find('.form-group').removeClass('active');
        $('.cal-holder').removeClass('active');
        // add active cls
        _self.closest('.form-group').addClass('active');
        $cal.addClass('active');
      });

      // confirm date range custom
      $(document).on('click', '#org-date-range-custom-confirm', function(e){
        e.preventDefault();
        // get start & end date
        var startDate = moment($('#org-date-range-start').val(), 'DD/MM/YYYY');
        var endDate = moment($('#org-date-range-end').val(), 'DD/MM/YYYY');
        var label = '';
        var minVal = '';
        var maxVal = '';

        if(startDate.isValid() && endDate.isValid()){
          // check if start < date or not
          if(endDate.isAfter(startDate)){
            // normal
            label += startDate.format('ll') + ' - ' + endDate.format('ll');
            minVal = startDate.format('YYYY-MM-DD');
            maxVal = endDate.format('YYYY-MM-DD');
          }else if(endDate.isSame(startDate)){
            // same
            label += startDate.format('ll');
            minVal = startDate.format('YYYY-MM-DD');
            maxVal = endDate.format('YYYY-MM-DD');
          }else{
            // switch between startDate & endDate
            label += endDate.format('ll') + ' - ' + startDate.format('ll');
            minVal = endDate.format('YYYY-MM-DD');
            maxVal = startDate.format('YYYY-MM-DD');
            $('#org-date-range-start').val(endDate.format('DD/MM/YYYY'));
            $('#org-date-range-end').val(startDate.format('DD/MM/YYYY'));
            $('#org-date-range-start-cal').data("DateTimePicker").date(endDate);
            $('#org-date-range-end-cal').data("DateTimePicker").date(startDate);
          }
        }else if(startDate.isValid() && !endDate.isValid()){
          label += startDate.format('ll') + ' - วันนี้';
          minVal = startDate.format('YYYY-MM-DD');
          maxVal = '';
        }else if(!startDate.isValid() && endDate.isValid()){
          label += 'ก่อนวันที่ ' + endDate.format('ll');
          minVal = '';
          maxVal = endDate.format('YYYY-MM-DD');
        }else{
          var curDate = moment();
          label += 'ก่อนวันที่ ' + curDate.format('ll');
          minVal = '';
          maxVal = curDate.format('YYYY-MM-DD');
        }
        // update button name
        var $btn = $('#org-time-selector');
        $btn.find('.text').html(label);
        var inputName = $btn.data('target');
        var $input = $('#' + inputName);
        var $min = $('#' + inputName.replace('time', 'min'));
        var $max = $('#' + inputName.replace('time', 'max'));
        $input.val('custom');
        $min.val(minVal);
        $max.val(maxVal);
        // hide modal
        $('#org-custom-range-modal').modal('hide');
      });
      // -- end ORG

      $(document).on('click', '.advance-search-block .dropdown-menu a', function(e){
        e.preventDefault();
        // get text
        var _self = $(this);
        var txt = _self.text();
        var val = _self.data('value');
        var btnName = _self.closest('.dropdown-menu').attr('aria-labelledby');
        var $btn = $('#' + btnName);
        var inputName = $btn.data('target');
        var $input = $('#' + inputName);

        // get root
        var root_id = _self.closest('.tab-pane').attr('id');

        /*if(root_id == 'search-news-program'){
          clearSearchCriteria('program');
        }else if(root_id == 'search-news-org'){
          clearSearchCriteria('org');
        }else if(root_id == 'search-news-tag'){
          clearSearchCriteria('news');
        }*/

        // check if this is custom date
        if(val == 'custom'){
          // show modal
          if(root_id == 'search-news-program'){
            $('#program-custom-range-modal').modal();
          }else if(root_id == 'search-news-org'){
            $('#org-custom-range-modal').modal();
          }else if(root_id == 'search-news-tag'){
            $('#custom-range-modal').modal();
          }
        }else{
          // replace text in the button
          $btn.find('.text').html(txt);
          $input.val(val);
        }
      });

      $(document).on('click', '.btn-search', function(e){
        $('#search-submit-btn').click();
      });
    }
  }
  return {
    init: init
  };
})();

module.exports = TPBS_AdvSearch;
